<script setup>
import { computed } from 'vue'
import { useAuthStore } from '@state/stores/auth'
import NavWordmark from './nav-wordmark'
import AccountMenu from './account-menu'

const authStore = useAuthStore()
const loggedIn = computed(() => authStore.loggedIn)
</script>

<template>
    <header class="phone-top-bar">
        <NavWordmark size="phone" />
        <div
            v-if="!loggedIn"
            class="auth-buttons"
        >
            <!-- A handler keeps BaseButton's own hover/press states: a handler-less BaseButton is a
                 pass-through label with pointer-events: none. Not inside a form, so the submit
                 trap doesn't apply. -->
            <BaseLink
                class="auth-link"
                name="login"
            >
                <BaseButton
                    variant="tertiary"
                    size="m"
                    @click="() => {}"
                >Log In</BaseButton>
            </BaseLink>
        </div>
        <div
            v-else
            class="user-details"
        >
            <AccountMenu />
        </div>
    </header>
</template>

<style lang="scss" scoped>
@use '@design' as *;

// Figma Phone Top Bar 531:1180: 56 on surface/chrome, wordmark 24 high, 16 side padding.
// The status-bar inset pads the top under viewport-fit=cover; the side insets are already
// padded by `body > #app`. The layout makes the bar sticky.
.phone-top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: calc(#{$size-phone-top-bar-height} + env(safe-area-inset-top));
    padding: env(safe-area-inset-top) $space-16 0;
    background: $c-surface-chrome;
}

.auth-buttons,
.user-details {
    display: flex;
    align-items: center;
}

// The link is the navigation target and must be pill-sized (#354); the radius lets the
// global focus outline follow the pill, and no underline in any link state.
.auth-link {
    display: inline-flex;
    text-decoration: none;
    border-radius: $radius-full;
}
</style>
